/**
 * @file コンポーネント：フル動画ページボタンリスト DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { ButtonNote } from "~/src/components/pages/Video/Video/ButtonNote";
import { ButtonPayment } from "~/src/components/pages/Video/Video/ButtonPayment";
import { ButtonThread } from "~/src/components/pages/Video/Video/ButtonThread";

// スタイル読み込み
import { StyledButtonlist, StyledButtonlistItem } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    return (
        <StyledButtonlist>
            {props.isPaid === true && props.isPurchased === false ? (
                // 有料コンテンツかつ未購入の場合
                <StyledButtonlistItem>
                    <ButtonPayment
                        setIsOpenPopupPayment={props.setIsOpenPopupPayment}
                    />
                </StyledButtonlistItem>
            ) : (
                // 有料コンテンツではない、または有料コンテンツで購入済みの場合
                <>
                    {/* ノートボタン */}
                    {props.isIdentificationUser === false && (
                        <StyledButtonlistItem>
                            <ButtonNote setIsOpenNote={props.setIsOpenNote} />
                        </StyledButtonlistItem>
                    )}
                    {/* スレッドボタン */}
                    {props.isLimitedReleaseVideo === true && (
                        <StyledButtonlistItem>
                            <ButtonThread
                                setIsOpenPopupThread={
                                    props.setIsOpenPopupThread
                                }
                            />
                        </StyledButtonlistItem>
                    )}
                </>
            )}
        </StyledButtonlist>
    );
};
